import { render, staticRenderFns } from "./IconFile.vue?vue&type=template&id=355550a6&scoped=true&"
import script from "./IconFile.vue?vue&type=script&lang=js&"
export * from "./IconFile.vue?vue&type=script&lang=js&"
import style0 from "./IconFile.vue?vue&type=style&index=0&id=355550a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355550a6",
  null
  
)

export default component.exports